import React from 'react';
import {Box, Typography} from '@mui/material';
import PaginatedAutocomplete from '../../../shared-components/PaginatedAutocomplete';
import {useLazyGetAllEmployeeProfilesQuery} from '../../../api/services/employeeService';

/* eslint-disable react/prop-types */

const getEmployeeLabel = (employee) => {
    if (!employee) return '';
    if (employee.label) return employee.label;
    return `${employee.preferredForename ?? ''} ${employee.preferredSurname ?? ''}`.trim();
};

const DocumentAudienceEmployeeFields = ({
    employeeFilters,
    onEmployeeFiltersChange,
}) => (
    <Box display="flex" flexDirection="column" gap={1}>
        <Typography variant="subtitle1" fontWeight="bold">
            Individual employees
        </Typography>
        <Typography variant="body2" color="text.secondary">
            Optionally pick specific employees. They can see this document even if they are not in the selected groups.
        </Typography>
        <PaginatedAutocomplete
            textFieldProps={{
                label: 'Employees',
                placeholder: 'Enter name, surname, or full name',
            }}
            fetchFn={useLazyGetAllEmployeeProfilesQuery}
            getOptionLabel={getEmployeeLabel}
            value={employeeFilters}
            onChange={(_event, newValue) => onEmployeeFiltersChange(newValue)}
        />
    </Box>
);

export default DocumentAudienceEmployeeFields;
